/**
 * @author Transoft.ltda on 18/05/2016.
 */

(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('routeService', routeService);

    routeService.$inject = ['$http', 'CONFIG', 'messageService'];

    function routeService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/routes';
        var service = {
            getRoutes: getRoutes,
            getRoutesDetails: getRoutesDetails,
            getRoutesPage: getRoutesPage,
            getRoute: getRoute,
            getRouteDetail: getRouteDetail,
            saveRoute: saveRoute,
            updateRoute: updateRoute,
            deleteRoute: deleteRoute,
            getDestinyByOriginIata: getDestinyByOriginIata,
            getRoutesByOriginDestinyIata: getRoutesByOriginDestinyIata
        }
        return service;

        function getRoutes(){
            return $http.get(urlBase)
        }

        function getRoutesDetails(detailed){
            return $http.get(urlBase + "?detailed=true")
        }

        function getRoutesPage(page, size, detailed){
            return $http.get(urlBase + '/page?page=' + page + '&size=' + size + '&detailed=' + detailed)
        }

        function getRoute(id){
            return $http.get(urlBase + "/" + id);
        }

        function getRouteDetail(id){
            return $http.get(urlBase + "/" + id +"?detailed=true")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function saveRoute(route){
            return $http.post(urlBase, route)
                .then(function(){
                    messageService.register('routeList');
                })
                .catch(function (error) {
                    if(error.data.message === 'Dato duplicado.'
                        || error.data.message === 'Duplicate Data.'){ //if(error.status === 409){
                        messageService.errorSegmentDuplicate();
                    }else{
                        messageService.registerError();
                    }
                })
        }

        function updateRoute(id,route){
            return $http.put(urlBase + "/" + id, route)
                .then(function(){
                    messageService.register('routeList');
                })
                .catch(function(){
                    messageService.registerError();
                })
        }

        function deleteRoute(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(){
                    messageService.registerDelete('');
                })
                .catch(function(){
                    messageService.registerDeleteError('');
                });
        }

        function getDestinyByOriginIata(iataOrigin){
            return $http.get(urlBase + "/iata/" + iataOrigin)
                .then(function(response){
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }

        function getRoutesByOriginDestinyIata(iataOrigin, iataDestiny){
            return $http.get(urlBase + "/iata/" + iataOrigin + "/destiny/" + iataDestiny)
                .then(function(response){
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }
    }
})();

